import React from "react";
import { MagnifyingGlassIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "../../contexts/LanguageContext";

export default function TicketsTopBar({
  total = 0,
  searchTerm = "",
  onSearchChange,
  statusFilter = "all",
  onStatusChange,
  categoryFilter = "all",
  onCategoryChange
}) {
  const { t } = useTranslation();
  return (
    <div className="bg-dashboardDark h-16 px-4 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <h2 className="text-white font-semibold text-lg">{t("tickets.title")}</h2>
        <span className="text-white font-semibold">({total})</span>
      </div>
      
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 px-3 py-1.5 border border-white rounded">
          <MagnifyingGlassIcon className="w-[18px] h-[18px] text-white" />
          <input
            type="text"
            placeholder={t("common.search")}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="bg-transparent text-white placeholder-white/70 text-sm font-light outline-none w-28"
          />
        </div>
        
        <select
          value={statusFilter}
          onChange={(e) => onStatusChange(e.target.value)}
          className="bg-transparent border border-white rounded px-3 py-1.5 text-white text-sm font-light outline-none"
        >
          <option value="all" className="text-dashboardDark">{t("tickets.filter.allStatus")}</option>
          <option value="open" className="text-dashboardDark">{t("tickets.filter.open")}</option>
          <option value="resolved" className="text-dashboardDark">{t("tickets.filter.resolved")}</option>
          <option value="closed" className="text-dashboardDark">{t("tickets.filter.closed")}</option>
        </select>

        <select
          value={categoryFilter}
          onChange={(e) => onCategoryChange(e.target.value)}
          className="bg-transparent border border-white rounded px-3 py-1.5 text-white text-sm font-light outline-none"
        >
          <option value="all" className="text-dashboardDark">{t("tickets.filter.allCategories")}</option>
          <option value="general" className="text-dashboardDark">{t("tickets.filter.general")}</option>
          <option value="support" className="text-dashboardDark">{t("tickets.filter.support")}</option>
          <option value="technical" className="text-dashboardDark">{t("tickets.filter.technical")}</option>
          <option value="billing" className="text-dashboardDark">{t("tickets.filter.billing")}</option>
        </select>
        
        <button className="flex items-center gap-2 px-3 py-1.5 border border-white rounded text-white text-sm font-light">
          <span>{t("common.sortBy")}</span>
          <ChevronDownIcon className="w-[18px] h-[18px] text-themeLightGray" />
        </button>
      </div>
    </div>
  );
}
